import { render } from "./TabStatistics.vue?vue&type=template&id=08b44c57&scoped=true"
import script from "./TabStatistics.vue?vue&type=script&lang=js"
export * from "./TabStatistics.vue?vue&type=script&lang=js"

import "./TabStatistics.vue?vue&type=style&index=0&id=08b44c57&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b44c57"]])

export default __exports__